import { render, staticRenderFns } from "./ContactFormMonte.vue?vue&type=template&id=4e6a2428&"
import script from "./ContactFormMonte.vue?vue&type=script&lang=js&"
export * from "./ContactFormMonte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports